export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_TESTING = process.env.NODE_ENV === 'testing';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
